var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63611 12.1003H14.3642V21.7713H9.63611V12.1003Z",
    fill: "#FFD60D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0203 12.0999H14.3644V21.7708H12.0203V12.0999Z",
    fill: "#FFB92C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7078 22.8835L14.364 19.6589H9.63586L7.29197 22.8835C7.13648 23.0974 7.11417 23.3804 7.23422 23.6161C7.35427 23.8517 7.59633 24 7.86075 24H16.1391C16.4035 24 16.6455 23.8517 16.7656 23.6161C16.8856 23.3804 16.8633 23.0974 16.7078 22.8835Z",
    fill: "#FFB92C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4219 0H2.57812C2.18981 0 1.875 0.314812 1.875 0.703125V6.48773C1.875 6.79252 2.07131 7.06256 2.36128 7.15659L5.43211 8.15231C5.78011 11.4689 8.59275 14.0625 12 14.0625C15.4073 14.0625 18.2199 11.4689 18.5679 8.15227L21.6387 7.15655C21.9286 7.06256 22.125 6.79247 22.125 6.48769V0.703125C22.125 0.314812 21.8102 0 21.4219 0V0ZM3.28125 1.40625H5.39569V6.66216L3.28125 5.97656V1.40625ZM20.7188 5.97656L18.6043 6.6622V1.40625H20.7188V5.97656Z",
    fill: "#FFB92C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4222 0H12.0203V14.0623C15.4185 14.0521 18.2209 11.4624 18.5682 8.15227L21.6391 7.15655C21.929 7.06256 22.1253 6.79247 22.1253 6.48769V0.703125C22.1253 0.314812 21.8105 0 21.4222 0V0ZM20.7191 5.97656L18.6047 6.6622V1.40625H20.7191V5.97656Z",
    fill: "#FF9100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3644 19.6589H12.0203V24H16.1395C16.4039 24 16.646 23.8517 16.766 23.6161C16.8861 23.3804 16.8637 23.0974 16.7083 22.8835L14.3644 19.6589Z",
    fill: "#FF9100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9058 5.63634C14.8356 5.42006 14.665 5.25112 14.4481 5.18292L13.2939 4.81978L12.5919 3.83423C12.46 3.64903 12.2466 3.53906 12.0192 3.53906C11.7918 3.53906 11.5784 3.64903 11.4465 3.83423L10.7445 4.81973L9.59028 5.18287C9.37339 5.25112 9.20286 5.42006 9.13259 5.63629C9.06228 5.85258 9.10095 6.08943 9.23633 6.27215L9.95665 7.24439L9.94531 8.45432C9.9432 8.68171 10.0512 8.89607 10.2351 9.02971C10.3568 9.11812 10.5019 9.16401 10.6485 9.16401C10.7235 9.16401 10.799 9.15201 10.872 9.12754L12.0192 8.74289L13.1665 9.12754C13.3821 9.19982 13.6193 9.16345 13.8033 9.02976C13.9873 8.89607 14.0952 8.68171 14.0931 8.45432L14.0818 7.24439L14.8021 6.2722C14.9375 6.08948 14.9761 5.85258 14.9058 5.63634Z",
    fill: "#FFD60D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 5.18292L13.295 4.81978L12.5929 3.83423C12.461 3.64903 12.2477 3.53906 12.0203 3.53906V8.74294L13.1675 9.12759C13.3831 9.19988 13.6203 9.1635 13.8043 9.02981C13.9883 8.89613 14.0962 8.68177 14.0941 8.45438L14.0828 7.24444L14.8032 6.27225C14.9385 6.08953 14.9772 5.85263 14.9069 5.63639C14.8366 5.42011 14.6661 5.25117 14.4492 5.18292Z",
    fill: "#FFB92C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.02347378abed8241d47ce24ceaebb64e.svg";
export { ForwardRef as ReactComponent };